import { AssetTypesState } from 'store/modules/assetTypes/types';
import { AssetTypeCode } from 'types/models/asset-type';
import SamplePoint from 'types/models/samplePoint';

import { getPipeType, getTroughType } from '../sensor-type';

export const getAssetTypeName = (samplePoint: Pick<SamplePoint, 'assetTypeId' | 'sensorTags'>, assetTypes: AssetTypesState): string | undefined => {
  const { assetTypeId } = samplePoint;
  const pipeType = assetTypeId === AssetTypeCode.PIPE ? getPipeType(samplePoint) : undefined;
  const troughModel = assetTypeId === AssetTypeCode.TROUGH ? getTroughType(samplePoint) : undefined;

  return pipeType || troughModel || assetTypes[assetTypeId]?.name;
};